<zn-stepper-wizard
  [stepDefinitions]="stepDefinitions"
  [finalActionLabelKey]="finalActionLabelKey"
  (submitWizardData)="onSubmitWizard($event)"
  (cancelWizard)="onCancel()"
/>

<lib-stepper-success-modal
  [isVisible]="successModalVisible()"
  [message]="successMessageKey"
  (isVisibleChange)="onSuccessModalVisibleChange($event)"
/>
